import React from 'react';
import { Bar, Creator, Del, Edit, Flex, NoteDetails, NoteDiv, StyledDate, SurgeryExchangeDetails, Time } from './CustomerCareNotes.styled';
import EditCard from './EditCard';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';

const NotesTwoDisplay = ({
    notesTwoDisplay,
    editNoteTwo,
    checkImpersonationActive,
    checkProxyActive,
    displayName,
    formatDateddmmmyy,
    countryISOCode,
    convertTime24To12,
    MDIEditDisable,
    MDIedit,
    handleEditTwo,
    DeleteIcon,
    handleDelete,
    setNotesCount,
    editNoteTwoValue,
    setEditNoteTwoValue,
    CloseBlue,
    handleCloseEditTwo,
    TickBlue,
    handleEditSaveTwo,
    setEditNoteTwo,
    setShowSuccessMessageTwo,
    isFromConsignmentBilling,
    isFromReportUsage,
    isFromConsignmentAdd,
    isFromEquity

}) => {
    const { t } = useTranslation();
    
  return (
      <>
          <NoteDiv>
              {notesTwoDisplay?.length > 0 ? (
                  notesTwoDisplay.map((item, index) => (
                      <React.Fragment key={index}>
                          <Flex
                              showBorder={
                                  editNoteTwo === index || !item.isNew
                                      ? false
                                      : true
                              }
                          >
                              <div
                                  style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      width: '100%',
                                  }}
                              >
                                  <Creator>
                                      {t('equity.surgery.createdBy')}{' '}
                                      {checkImpersonationActive() ||
                                      checkProxyActive()
                                          ? sessionStorage.getItem(
                                                'ProxyUserRole'
                                            )
                                        : <span className="customer-care-note-author-dt-mask">{(item.userName
                                                ? item.userName
                                            : displayName) || ''}</span>}
                                  </Creator>
                                  <Bar>|</Bar>
                                  <StyledDate>
                                      {formatDateddmmmyy(
                                          item.creationDate,
                                          countryISOCode,
                                          true
                                      )}
                                  </StyledDate>
                                  <Bar>|</Bar>
                                  <Time>
                                      {convertTime24To12(
                                          new Date(item.creationDate)
                                      )}{' '}
                                  </Time>
                              </div>
                              {item?.isNew ? (
                                  <div
                                      style={{
                                          display: 'flex',
                                          gap: '10px',
                                      }}
                                  >
                                      <Edit>
                                          <img
                                              src={
                                                  editNoteTwo === index
                                                      ? MDIEditDisable
                                                      : MDIedit
                                              }
                                              alt="Edit note"
                                              onClick={() =>
                                                  handleEditTwo(item, index)
                                              }
                                          />
                                      </Edit>
                                      <Del>
                                          <img
                                              src={DeleteIcon}
                                              onClick={() => {
                                                  handleDelete(item, index);
                                                  handleDelete(item, index);
                                                  setNotesCount(
                                                      (prev) => prev - 1
                                                  );
                                              }}
                                          />
                                      </Del>
                                  </div>
                              ) : item?.isDelete || item?.isEdit ? (
                                  <div
                                      style={{
                                          display: 'flex',
                                          gap: '10px',
                                      }}
                                  >
                                      {item?.isEdit && (
                                          <Edit>
                                              <img
                                                  src={
                                                      editNoteTwo === index
                                                          ? MDIEditDisable
                                                          : MDIedit
                                                  }
                                                  alt="Edit note"
                                                  onClick={() =>
                                                      handleEditTwo(item, index)
                                                  }
                                              />
                                          </Edit>
                                      )}
                                      {item?.isDelete && (
                                          <Del>
                                              <img
                                                  src={DeleteIcon}
                                                  onClick={() => {
                                                      handleDelete(item, index);
                                                      handleDelete(item, index);
                                                      setNotesCount(
                                                          (prev) => prev - 1
                                                      );
                                                  }}
                                              />
                                          </Del>
                                      )}
                                  </div>
                              ) : null}
                          </Flex>
                          {editNoteTwo === index && (
                              <div
                                  style={{
                                      borderLeft: '2px solid #12c8f7',
                                  }}
                              >
                                  <EditCard
                                      value={editNoteTwoValue ?? item.note}
                                      editTextHandler={(e) => {
                                          setEditNoteTwoValue(e.target.value);
                                      }}
                                      CloseBlue={CloseBlue}
                                      closeEditHandler={handleCloseEditTwo}
                                      TickBlue={TickBlue}
                                      blueTickHandler={() => {
                                          const isEmptyValue =
                                              !editNoteTwoValue ||
                                              editNoteTwoValue.trim() === '';

                                          handleEditSaveTwo(index);
                                          setEditNoteTwoValue(null);
                                          setEditNoteTwo(null);

                                          if (!isEmptyValue) {
                                              setShowSuccessMessageTwo(true);
                                              setTimeout(() => {
                                                  try {
                                                      setShowSuccessMessageTwo(
                                                          false
                                                      );
                                                  }
                                                  catch (error) {
                                                      logErrorToConsole(error);
                                                  }
                                              }, 4000);
                                          }
                                      }}
                                  />
                              </div>
                          )}
                          {item.typeOfNote === 'CaseNotes' ? (
                              <>
                                  {item.updatedSurgeryDate && (
                                      <div
                                          style={{
                                              fontFamily:
                                                  FONT_FAMILY_DEMI,
                                              color: '#202124',
                                              fontSize: '12px',
                                              paddingLeft:
                                                  window.innerWidth <=
                                                  sizes.mobileDevice
                                                      ? '16px'
                                                      : '20px',
                                          }}
                                      >
                                          {item.updatedSurgeryDate}
                                      </div>
                                  )}
                                  <ol
                                      type="a"
                                      style={{
                                          paddingLeft:
                                              window.innerWidth <=
                                              sizes.mobileDevice
                                                  ? '16px'
                                                  : '20px',
                                          margin: '0',
                                      }}
                                  >
                                      {item.note
                                          .split(';')
                                          .map((element, index) => {
                                              return (
                                                  <SurgeryExchangeDetails className="customer-care-note-two-text-dt-mask"
                                                      key={index}
                                                  >
                                                      {element}
                                                  </SurgeryExchangeDetails>
                                              );
                                          })}
                                  </ol>
                              </>
                          ) : (
                              editNoteTwo !== index && (
                                  <NoteDetails
                                      className="customer-care-note-two-text-dt-mask"
                                      hideBorder={item.isNew ? false : true}
                                  >
                                      {item.note}
                                  </NoteDetails>
                              )
                          )}

                          {/* <Roles>{item.physician}</Roles> */}
                      </React.Fragment>
                  ))
              ) : (
                  <div
                      style={{
                          fontFamily: 'AvenirNextWorld Italic',
                          fontSize: '14px',
                          color: '#202124',
                          opacity: '0.7',
                          padding: '20px',
                      }}
                  >
                      {isFromConsignmentAdd || isFromEquity
                          ? t('reportUsage.noCustomerCareNotes')
                          : isFromConsignmentBilling
                          ? t(
                                'reportUsage.noCustomerCareConsignmentReplenishment'
                            )
                          : isFromReportUsage
                          ? t('common.noCustomerCareReplenishNotes')
                          : t(
                                'scheduleSurgery.surgery.SurgeryReviewAndSuccess.NoSurgeryNotescreatedyet'
                            )}
                  </div>
              )}
          </NoteDiv>
      </>
  );
};

export default NotesTwoDisplay;